/**
 * code taken from ./main.js except for @camtv/front-base-css/main which breaks form
 */

import ContactUsDialog from './contact_us_dialog'
import CtvLegalDialog from '@camtv/front-base-ui/lit/legal-dialog'
import './forms_handler'
import "@3technologysrl/front-gdpr"

window.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.ContactUsCTA').forEach((el) => {
        el.onclick = (evt) => {
            let page = el.getAttribute("data-page");
            let subject = el.getAttribute("data-subject");
            let title = el.getAttribute("data-title");
            evt.preventDefault();
            ContactUsDialog.Show(document.querySelector('#CONTACT_US'), page, subject, title);
        }
    })

    document.querySelectorAll(".CookiePolicy").forEach((el) => el.onclick = (evt) => {
        evt.preventDefault();
        CtvLegalDialog.ShowCookies("https://static.3technology.it/legal/cookies.md")
    })
    document.querySelectorAll(".PrivacyPolicy").forEach((el) => el.onclick = (evt) => {
        evt.preventDefault();
        CtvLegalDialog.ShowPrivacy("https://static.3technology.it/legal/privacy.md")
    })

});

function ToggleAction() {
    // var x = document.getElementById("slidabile");
    // var y = document.getElementById("thejob");
    // var z = document.getElementById("theapplication");

    //if (y.style.display === "none") {
    if ($('#slidabile').hasClass('applying')) {
        $('#slidabile').removeClass('applying');
        $('.button-set-apply').removeClass('applying');

    } else {
        $('#slidabile').addClass('applying');
        $('.button-set-apply').addClass('applying');
    }
    //}
}

window.ToggleAction = ToggleAction;